import { useContext } from 'react';

import type {
  ChatActions,
  ChatContextValue,
  ChatState
} from '@/features/ai-chat/state/chat.context';
import { ChatActionsContext, ChatStateContext } from '@/features/ai-chat/state/chat.context';

export function useChatState(): ChatState {
  const ctx = useContext(ChatStateContext);
  if (!ctx) throw new Error('useChatState must be used within a ChatProvider');
  return ctx;
}

export function useChatActions(): ChatActions {
  const ctx = useContext(ChatActionsContext);
  if (!ctx) throw new Error('useChatActions must be used within a ChatProvider');
  return ctx;
}

export function useChat(): ChatContextValue {
  return { ...useChatState(), ...useChatActions() };
}
